<template>
  <el-cascader
    :value="value"
    :options="cascaderOptions"
    :props="cascaderProps"
    clearable
    placeholder="请选择团队"
    style="width: 100%"
    @change="handleValueUpdate"
  />
</template>

<script>
import { Vue, Component, Model } from 'vue-property-decorator';

@Component({
  name: 'TeamTreeSelect'
})
export default class TeamTreeSelect extends Vue {
  @Model('change', { default: null }) value

  rawTeamData = []

  // 级联选择器的配置
  cascaderProps = {
    value: 'id',
    label: 'name',
    children: 'children',
    checkStrictly: true, // 允许选择任意一级
    emitPath: false, // 只返回选中节点的value，不返回完整路径
    expandTrigger: 'hover' // 悬停展开子级，点击直接选择当前级
  }

  get cascaderOptions() {
    return this.processTeamData(this.rawTeamData)
  }

  async mounted() {
    await this.loadTeamData()
  }

  async loadTeamData() {
    try {
      const data = await this.$request.get('teams/tree')
      this.rawTeamData = data || []
    } catch (error) {
      console.error('加载团队数据失败:', error)
      this.rawTeamData = []
    }
  }

  processTeamData(teams) {
    return teams.map(team => {
      const processedTeam = {
        id: team.id,
        name: team.name,
        color: team.color,
        kind: team.kind
      }

      if (team.children && team.children.length > 0) {
        // 只显示子级内容，不添加"选择xxx"选项
        processedTeam.children = team.children.map(child => ({
          id: child.id,
          name: child.name,
          color: child.color,
          kind: child.kind
        }))
      }

      return processedTeam
    })
  }

  handleValueUpdate(value) {
    this.$emit('change', value)
  }
}
</script>

<style lang="scss" scoped>
</style>
